import React, { FC } from "react";
import "./Tooltip.scss";
import RcTooltip from "rc-tooltip";
import { TooltipProps as RcTooltipProps } from "rc-tooltip/lib/Tooltip";
import { getPopupContainer } from "../../shared/getPopupContainer";

interface Props extends Omit<RcTooltipProps, "placement"> {
  placement?:
    | "top"
    | "bottom"
    | "right"
    | "leftTop"
    | "leftBottom"
    | "rightTop"
    | "rightBottom"
    | "topLeft"
    | "topRight"
    | "bottomLeft"
    | "bottomRight";
}
export type TooltipProps = Props;

const Tooltip: FC<Props> = ({ ...props }) => {
  return (
    <RcTooltip
      placement={"top"}
      animation={"zoom"}
      getTooltipContainer={getPopupContainer}
      {...props}
    />
  );
};

export default Tooltip;
